import { createSlice } from '@reduxjs/toolkit';
import { fetchNetworks, selectNetwork } from '../networks/networksSlice';
import { payWithPayPal, setCreditCardData, payWithCreditCard } from '../transfer/transferSlice';
import { sendSmsToSender } from '../sender/senderSlice';

export const steps = {
  receiverPhoneNumber: 1,
  receiverNetwork: 2,
  selectAmount: 3,
  paymentMethods: 4, //also CreditCardDetails
  receiptDetails: 5, // sender
  twoFactorAuthorization: 6,
  success: 7,
};

const initialState = {
  step: steps.receiverPhoneNumber,
  reviled: [steps.receiverPhoneNumber],
};

// const initialState = {
//   step: 5,
//   reviled: [5],
// };

const stepSlice = createSlice({
  name: 'step',
  initialState,
  reducers: {
    setStep(state, action) {
      if (state.step > 3) {
        state.reviled = [steps.receiverPhoneNumber, steps.receiverNetwork, steps.selectAmount];
      }
      state.step = action.payload;
      state.reviled.push(action.payload);
    },
    resetToStep: (state, action) => {
      let reviled = [];
      for (let i = 1; i <= action.payload; i++) {
        reviled.push(i);
      }
      state.step = action.payload;
      state.reviled = reviled;
    },
    setSingleStep: (state, action) => {
      state.step = action.payload;
      state.reviled = [action.payload];
    },
  },
  extraReducers: {
    [fetchNetworks.fulfilled]: (state, action) => {
      if (action.payload.length > 0) {
        state.step = steps.receiverNetwork;
        state.reviled.push(steps.receiverNetwork);
      }
    },
    [selectNetwork]: (state) => {
      state.reviled = [steps.receiverPhoneNumber, steps.receiverNetwork];
    },
    [payWithPayPal.fulfilled]: (state) => {
      state.step = steps.success;
      state.reviled = [steps.success];
    },

    [payWithCreditCard.fulfilled]: (state) => {
      state.step = steps.success;
      state.reviled = [steps.success];
    },

    [setCreditCardData]: (state) => {
      state.step = steps.receiptDetails;
      state.reviled = [steps.receiptDetails];
    },

    [sendSmsToSender.fulfilled]: (state) => {
      state.step = steps.twoFactorAuthorization;
      state.reviled = [steps.receiptDetails, steps.twoFactorAuthorization];
    },

    RESET: (state) => {
      state.step = steps.receiverPhoneNumber;
      state.reviled = [steps.receiverPhoneNumber];
    },
  },
});

export const { setStep, resetToStep, setSingleStep } = stepSlice.actions;

export default stepSlice.reducer;
